import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { CommonAppState } from './CommonAppState';

export const useCommonTypedSelector: TypedUseSelectorHook<CommonAppState> =
  useSelector;

export default useCommonTypedSelector;
